import styled from 'styled-components';
import { TextInfo } from '../styled';

const AddTools = styled(TextInfo)`
  margin: 26px 0 !important;
`;
AddTools.displayName = 'AddTools';

export default AddTools;
